import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div>
          <strong>WhoIsYourSanta</strong>
          <p>© {new Date().getFullYear()} WhoIsYourSanta. All rights reserved.</p>
        </div>
        <div className="footer-links">
          <Link to="/legal/terms">
            Terms of Service
          </Link>
          <Link to="/legal/privacy">
            Privacy Policy
          </Link>
          <a href="mailto:support@whoisyoursanta.com">
            Contact Us
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
